import { PropsWithChildren, createContext } from "react";

import { useAchievementsModal } from "@/components/Modals/Achievements";
import { useAirdropClaimedModal } from "@/components/Modals/AirdropClaimed";
import { useFAQModal } from "@/components/Modals/FAQ";
import { useLevelModal } from "@/components/Modals/Level";
import { useNFTPurchasedModal } from "@/components/Modals/NFTPurchased";
import { useWarningModal } from "@/components/Modals/Warning";
import { ModalContextProps } from "@/interfaces/modals";

export const ModalContext = createContext<ModalContextProps>({} as ModalContextProps);

export function ModalProvider({ children }: PropsWithChildren) {
  const levelModalProps = useLevelModal();
  const nftPurchasedModalProps = useNFTPurchasedModal();
  const faqProps = useFAQModal();
  const achievementsProps = useAchievementsModal();
  const airdropClaimedProps = useAirdropClaimedModal();
  const warningModalProps = useWarningModal();

  return (
    <ModalContext.Provider
      value={{
        level: levelModalProps,
        nftPurchased: nftPurchasedModalProps,
        faq: faqProps,
        achievements: achievementsProps,
        airdropClaimed: airdropClaimedProps,
        warningModal: warningModalProps,
      }}
    >
      {levelModalProps.modal}
      {nftPurchasedModalProps.modal}
      {faqProps.modal}
      {achievementsProps.modal}
      {airdropClaimedProps.modal}
      {warningModalProps.modal}
      {children}
    </ModalContext.Provider>
  );
}
